import PermissionAPI from 'api/permission';
import PermissionGroupAPI from 'api/permissiongroup';
import RoleAPI from 'api/role';
import guidEmpty from 'constants/guid-empty';
import CommonStatus from 'constants/types/common-status';
import { clone } from 'coreutils-js';
import { setParamsUrl } from 'hooks/useFilterParams';
import {
  action, computed, makeAutoObservable, observable
} from 'mobx';
import RootStore from 'stores/RootStore';

const initFilters = {
  pageIndex: 1,
  pageSize: 20,
  keyword: "",
  status: CommonStatus.ACTIVED,
};

export default class RoleStore {
  roleApi: RoleAPI;

  permissionApi: PermissionAPI;

  permissionGroupApi: PermissionGroupAPI;

  // rootStore: RootStore;

  constructor({ refreshToken }) {
    makeAutoObservable(this);
    // this.rootStore = rootStore;
    this.roleApi = new RoleAPI({ refreshToken });
    this.permissionApi = new PermissionAPI({ refreshToken });
    this.permissionGroupApi = new PermissionGroupAPI({ refreshToken });
  }

  @observable data = [];
  @observable total = 0;
  @observable loading = true;
  @observable rawFilters = clone(initFilters);
  @observable initFilters = clone(initFilters);

  @computed get filters(): any {
    const rs = {} as any;
    
    Object.keys(this.rawFilters).forEach((key) => {
      switch (key) {
        default:
          rs[key] = this.rawFilters[key];
          break;
      }
    });

    Object.keys(rs).forEach((key) => {
      if (rs[key] === null || rs[key] === 'null' || rs[key] === '') {
        delete rs[key];
      }
    });

    return rs;
  }

  @action
  setFilters(updatedFilters = {}, isReplace = false) {
    if (isReplace) this.rawFilters = { ...updatedFilters };
    else Object.assign(this.rawFilters, updatedFilters);
    setParamsUrl(this.rawFilters as any, { replace: true });
  }

  @action getData = (applicationId, channelId = guidEmpty) => {
    this.loading = true;
    this.roleApi.searchRole({
      ...this.filters,
      applicationId,
      channelId
    })
      .then(({ data }) => {
        this.data = data.data || [];
        this.total = data.total || 0;
      })
      .finally(() => {
        this.loading = false;
      });
  };
}
